import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getNotification = id => {
  return http.get(
    `${getBaseUrl()}/notification/${id}`
  );
};

export const getNotifications = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/notification`
    );
  }
  return http.get(
    `${getBaseUrl()}/notification?${paginate}`
  );
};

export const getUserNotifications = (userId) => {
  return http.get(
    `${getBaseUrl()}/user_notification/${userId}`
  );
};

export const updateNotification = data => {
  return http.put(
    `${getBaseUrl()}/notification/${data.id}`,
    data
  );
};

export const submitNotification = data => {
  return http.post(
    `${getBaseUrl()}/notification`,
    data
  );
};

export const updateNotificationRead = data => {
  return http.put(
    `${getBaseUrl()}/notification_read`,
    data
  );
};

export const submitNotificationResponse = data => {
  http.hasFile();
  return http.post(
    `${getBaseUrl()}/notification_response`,
    data
  );
};
